import React from 'react';
import MaterialIcon from '@/components/MaterialIcon';

/**
 * フロアマップ連携機能详细说明 - SEO优化新增
 * 重点突出"フロアマップ"差异化功能
 */
export const FloorMapDetailSection: React.FC = () => {
  const features = [
    { icon: 'location_on', text: '店舗名を言うだけで地図上に位置を表示' },
    { icon: 'map', text: '現在地から目的地までの最短ルートを表示' },
    { icon: 'elevator', text: 'エレベーター・エスカレーター優先ルート設定' },
    { icon: 'accessible', text: 'バリアフリールートの自動案内' },
    { icon: 'wc', text: 'トイレ・授乳室・喫煙所の最寄り案内' },
    { icon: 'local_parking', text: '駐車場からのルート案内' },
  ];

  return (
    <section className="w-full px-4 md:px-10 lg:px-40 py-16 bg-gray-50">
      <div className="max-w-[900px] w-full mx-auto">
        <h2 className="text-2xl md:text-3xl font-black text-solution-text mb-6 text-center">
          フロアマップ連携機能 - 他のチャットボットとの決定的な違い
        </h2>
        <p className="text-solution-text-secondary text-base leading-relaxed mb-8 text-center">
          一般的なAIチャットボットは文字での案内のみですが、GBase Supportは
          フロアマップと完全に連携。お客様の質問に対して、
          視覚的な地図上で目的地を表示し、現在地からのルートを案内します。
        </p>

        <h3 className="text-xl font-bold text-solution-text mb-6 text-center">フロアマップ連携でできること</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center gap-3 bg-white rounded-xl p-4 border border-gray-100">
              <div className="w-10 h-10 rounded-full bg-solution-orange/10 flex items-center justify-center shrink-0">
                <MaterialIcon name={feature.icon} className="text-solution-orange text-xl" />
              </div>
              <p className="text-solution-text text-sm font-medium">{feature.text}</p>
            </div>
          ))}
        </div>

        <p className="text-solution-text-secondary text-base leading-relaxed text-center">
          従来型のフロアマップは静的な画像表示のみでしたが、
          AIチャットボットとの連携により、インタラクティブな案内が可能になりました。
        </p>
      </div>
    </section>
  );
};

export default FloorMapDetailSection;
